import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dragHandler: {
		id: 'portal-settings-request-groups.portal-group.ticket-type-list.ticket-type-item.drag-handler',
		defaultMessage:
			'This item can be dragged and dropped to reorder its position in the group. Alternatively press space bar and the arrow keys',
		description: 'Accessibility label for the drag icon on a request form item',
	},
	removeButton: {
		id: 'portal-settings-request-groups.portal-group.ticket-type-list.ticket-type-item.remove-button',
		defaultMessage: 'Clicking this button will remove the request form {formName} from the group',
		description: 'Accessibility label for the remove button on a request form item',
	},
	removeIconTooltip: {
		id: 'portal-settings-request-groups.portal-group.ticket-type-list.ticket-type-item.remove-icon-tooltip',
		defaultMessage: 'Remove from group',
		description:
			'Text show in tooltip on hover of the remove icon. Removes request form from the request group.',
	},
});
